<template>
  <div>
    <b-row>
      <b-col md="12">
        <InputSelect
          title="Save Response As"
          name="SaveResponseAs"
          isRequired
          v-model="response.content.UserInput.SaveResponseAs"
          :options="conditionList"
          valueField="id"
          textField="name"
          @onDataChange="handleChangeSaveResponseAs"
          :isValidate="v.content.UserInput.SaveResponseAs.$error"
          :v="v.content.UserInput.SaveResponseAs"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputText
          v-model="response.content.UserInput.SuccessFormat"
          textFloat="If User Input Success Format"
          placeholder="If User Input Success Format"
          type="text"
          name="SuccessFormat"
          isRequired
          :isValidate="v.content.UserInput.SuccessFormat.$error"
          :v="v.content.UserInput.SuccessFormat"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputText
          v-model="response.content.UserInput.WrongFormat"
          textFloat="If User Input Wrong Format"
          placeholder="If User Input Wrong Format"
          type="text"
          name="WrongFormat"
          isRequired
          :isValidate="v.content.UserInput.WrongFormat.$error"
          :v="v.content.UserInput.WrongFormat"
          />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <InputText
          v-model="response.content.UserInput.Retry"
          textFloat="Retry"
          placeholder="Retry"
          type="text"
          name="Retry"
          isRequired
          :isValidate="v.content.UserInput.Retry.$error"
          :v="v.content.UserInput.Retry"
          />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";

export default {
  components: {
    InputText,
    InputSelect
  },
  props: {
    response: {
      required: true,
      type: Object
    },
    v: {
      required: false,
      type: Object
    },
    conditionList: {
      required: true,
      type: Array,
    },
  },
  methods: {
    handleChangeSaveResponseAs(value) {
      this.response.content.UserInput.SaveResponseAs = value;
    },
  },
};
</script>
